/**
 * Em breve (<e-upcoming>).
 *
 * - "Avise-me da <linha>" marca a linha no formulário, rola até ele e põe o
 *   foco no e-mail. Sem JS, ou com o formulário já enviado, o link só leva à
 *   âncora do formulário.
 * - ?linha=<handle da coleção> (links das coleções ainda vazias, e-collection)
 *   já abre com a linha marcada no formulário. A âncora #em-breve faz a
 *   rolagem; o foco fica onde está.
 * - Faixa da linha: com mouse, as camadas do pattern seguem o ponteiro em
 *   profundidades diferentes e uma luz acompanha o cursor. O CSS lê --px/--py
 *   (de -1 a 1, posição no rótulo) e --gx/--gy (px, posição na faixa). No
 *   máximo uma atualização por quadro, com as leituras de posição antes das
 *   escritas. Desligado no toque e com movimento reduzido (nesse caso o CSS
 *   também ignora as variáveis).
 */

const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

class EUpcoming extends HTMLElement {
  activeCard = null;
  activeBand = null;
  pointer = null;
  frame = 0;

  connectedCallback() {
    this.selectRequestedLine();
    this.addEventListener('click', this.handleClick);
    this.addEventListener('pointermove', this.handlePointerMove);
    this.addEventListener('pointerleave', this.handlePointerLeave);
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.frame = 0;
  }

  selectRequestedLine() {
    const line = new URLSearchParams(window.location.search).get('linha');
    if (!line) return;
    const option = this.querySelector(`[data-e-upcoming-line="${CSS.escape(line)}"]`);
    if (option) option.checked = true;
  }

  handleClick = (event) => {
    const pick = event.target.closest('[data-e-upcoming-pick]');
    if (!pick) return;
    const option = this.querySelector(`[data-e-upcoming-option="${CSS.escape(pick.dataset.eUpcomingPick)}"]`);
    const email = option?.form?.elements.namedItem('contact[email]');
    if (!email) return;
    event.preventDefault();
    option.checked = true;
    option.form.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
    email.focus({ preventScroll: true });
  };

  handlePointerMove = (event) => {
    if (event.pointerType === 'touch' || !finePointer.matches || reducedMotion.matches) return;
    const card = event.target.closest('[data-e-upcoming-card]');
    if (card !== this.activeCard) this.setActiveCard(card);
    if (!card) return;
    this.pointer = { x: event.clientX, y: event.clientY };
    if (!this.frame) this.frame = requestAnimationFrame(this.render);
  };

  handlePointerLeave = () => this.setActiveCard(null);

  /* A faixa que perde o ponteiro volta ao centro; a luz some onde estava. */
  setActiveCard(card) {
    if (this.activeBand) {
      this.activeBand.removeAttribute('data-active');
      this.activeBand.style.setProperty('--px', '0');
      this.activeBand.style.setProperty('--py', '0');
    }
    this.activeCard = card;
    this.activeBand = card?.querySelector('[data-e-upcoming-band]') ?? null;
    this.activeBand?.setAttribute('data-active', '');
  }

  render = () => {
    this.frame = 0;
    const { activeCard: card, activeBand: band, pointer } = this;
    if (!card || !band || !pointer) return;
    const cardBox = card.getBoundingClientRect();
    const bandBox = band.getBoundingClientRect();
    const x = ((pointer.x - cardBox.left) / cardBox.width) * 2 - 1;
    const y = ((pointer.y - cardBox.top) / cardBox.height) * 2 - 1;
    band.style.setProperty('--px', x.toFixed(3));
    band.style.setProperty('--py', y.toFixed(3));
    band.style.setProperty('--gx', `${Math.round(pointer.x - bandBox.left)}px`);
    band.style.setProperty('--gy', `${Math.round(pointer.y - bandBox.top)}px`);
  };
}

if (!customElements.get('e-upcoming')) customElements.define('e-upcoming', EUpcoming);
